import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarIconGrey = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#B7C3CD",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0.5 1.5H15.5V15.5H0.5z" }),
			/* @__PURE__ */ _jsx("path", { d: "M0.5 1.5H15.5V5.5H0.5z" }),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M.5.5H1.5V3.5H.5zM7.5.5H8.5V3.5H7.5z",
				transform: "translate(4)"
			}) })
		]
	})
});
export default SvgCalendarIconGrey;
